import { createIcon } from './createIcon'

export const CicrleCheckIcon = createIcon({
  displayName: 'CicrleCheckIcon',
  viewBox: '0 0 22 22',
  path: [
    <path
      d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M15.011 8.38399L10.6535 14.1935C10.5566 14.3222 10.4332 14.4287 10.2917 14.5058C10.1501 14.5829 9.99368 14.6287 9.83292 14.6402C9.67217 14.6517 9.51081 14.6286 9.35972 14.5725C9.20864 14.5164 9.07132 14.4286 8.95703 14.315L6.70703 12.065"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
})
